export interface ClefQuestion {
  id: string;
  question: string;
  options: string[];
  answerIndex: number;
  explanation: string;
  /** sinal mostrado no lugar da pauta (ex.: sinais de repetição, dinâmica, andamento) */
  glyph?: string;
  /** legenda curta do sinal, exibida como apoio visual */
  glyphHint?: string;
}

/** Perguntas de apoio para a aula "Clave de sol". */
export const CLEF_QUESTIONS: ClefQuestion[] = [
  {
    id: 'clef-name',
    question: 'Qual é o nome da clave desenhada no início da pauta?',
    options: ['Clave de sol', 'Clave de fá', 'Clave de dó'],
    answerIndex: 0,
    explanation: 'É a clave de sol, usada para as notas mais agudas e para a mão direita no teclado.',
  },
  {
    id: 'clef-line',
    question: 'Em qual linha a clave de sol enrola?',
    options: ['Primeira linha', 'Segunda linha', 'Terceira linha'],
    answerIndex: 1,
    explanation: 'Ela enrola na segunda linha de baixo para cima. Por isso essa linha é o Sol (Sol4).',
  },
  {
    id: 'clef-function',
    question: 'Para que serve a clave de sol?',
    options: [
      'Marcar a altura das notas na pauta',
      'Marcar a duração das notas',
      'Marcar a velocidade da música',
    ],
    answerIndex: 0,
    explanation: 'A clave define qual nota fica em cada linha e espaço da pauta.',
  },
  {
    id: 'clef-order',
    question: 'Começando por baixo, qual é a ordem das cinco linhas na clave de sol?',
    options: [
      'Mi, Sol, Si, Ré, Fá',
      'Dó, Ré, Mi, Fá, Sol',
      'Fá, Lá, Dó, Mi, Sol',
    ],
    answerIndex: 0,
    explanation: 'As linhas são Mi4, Sol4, Si4, Ré5 e Fá5.',
  },
];